// One pass: group by local calendar day, sort each day oldest→newest, and
// return the day keys in that same order. Callers should render `dates` and
// look messages up in `byDate` from this object, instead of sorting again.
export function groupMessagesByDate(messages) {
  const byDate = new Map();

  messages?.forEach(message => {
    const dateKey = new Date(message.createdAt).toDateString();
    let dayMessages = byDate.get(dateKey);

    if (!dayMessages) {
      dayMessages = [];
      byDate.set(dateKey, dayMessages);
    }

    dayMessages.push(message);
  });

  for (const dayMessages of byDate.values()) {
    // When promote stamps a system row and the first bubble in the same second,
    // keep system context above the user message (stable sort alone keeps
    // newest-first array order and puts the bubble first).
    dayMessages.sort((a, b) => {
      const byTime = new Date(a.createdAt) - new Date(b.createdAt);
      if (byTime !== 0) return byTime;
      if (Boolean(a.isSystem) !== Boolean(b.isSystem)) return a.isSystem ? -1 : 1;
      return 0;
    });
  }

  const dates = Array.from(byDate.keys()).sort((a, b) => new Date(a) - new Date(b));

  return { dates, byDate };
}
